import { authFetch } from "./authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";
import { normalizeApiMessage } from "lib/i18n/apiMessage";

const EMPTY_USERS_SUMMARY = {
  totalUsers: "0",
  roleCounts: { master: "0", admin: "0", manager: "0", user: "0" },
  activeUsers1h: "0",
  inactiveUsers1m: "0",
};

export async function getAdminUsersDashboard() {
  try {
    const path = `${BACKEND_URL}/admin/get_users_dashboard`;

    const res = await authFetch(
      path,
      { method: "GET" },
      { refreshUrlIncludes: "auth/refresh" },
    );

    const result = await res.json().catch(() => null);

    if (!result) {
      return {
        success: false,
        ...normalizeApiMessage(
          { message: "Failed to parse server response." },
          "Failed to parse server response.",
        ),
        messageKey: "api.common.serverError",
        summary: EMPTY_USERS_SUMMARY,
        kpis: [],
        users: [],
      };
    }

    if (!res.ok || result?.success !== true) {
      return {
        success: false,
        ...normalizeApiMessage(result, "Failed to fetch user dashboard."),
        summary: EMPTY_USERS_SUMMARY,
        kpis: [],
        users: [],
      };
    }

    const data = result?.data ?? {};

    const kpis = [
      {
        title: "전체 사용자",
        value: data.total_user_count ?? "0",
        tone: "blue",
        inc30d: data.user_new_30d,
        date: "30d",
      },
      {
        title: "권한 분포 (마스터/관리자/매니저/일반 사용자)",
        value: `${data.master_count ?? "0"} / ${data.admin_count ?? "0"} / ${data.manager_count ?? "0"} / ${data.user_count ?? "0"}`,
        tone: "green",
        inc30ds: [
          data.master_role_new_30d ?? "0",
          data.admin_role_new_30d ?? "0",
          data.manager_role_new_30d ?? "0",
          data.user_role_new_30d ?? "0",
        ],
        date: "30d",
      },
      {
        title: "활성 사용자",
        value: data.total_active_1m ?? "0",
        tone: "orange",
        label: "최근 1개월 내 로그인",
      },
      {
        title: "비활성 사용자",
        value: data.total_inactive_1m ?? "0",
        tone: "red",
        label: "1개월 이상 로그인 없음",
      },
    ];

    return {
      success: true,
      ...normalizeApiMessage(result, "User dashboard loaded successfully."),
      kpis,
      users: Array.isArray(data?.users) ? data.users : [],
      activities: Array.isArray(data?.activities) ? data.activities : [],
    };
  } catch (error) {
    return {
      success: false,
      ...normalizeApiMessage(
        { message: error?.message || "Network error occurred." },
        error?.message || "Network error occurred.",
      ),
      messageKey: "api.common.networkError",
      summary: EMPTY_USERS_SUMMARY,
      kpis: [],
      users: [],
      activities: [],
    };
  }
}
